import { ITheme } from '@fluentui/react/lib/Styling';
import { ILinkStyleProps, ILinkStyles } from '@fluentui/react/lib/Link';

export function getLinkStyles(themeName: string, _theme: ITheme) {
  return (props: ILinkStyleProps): Partial<ILinkStyles> => {
    const { isDisabled, theme } = props;
    const { palette } = theme;

    const linkColor =
      themeName === 'contrast' ? palette.themeDark : palette.themePrimary;

    const stateSelectors = {
      ':focus': {
        color: linkColor,
        textDecoration: 'underline'
      }
    };

    const activeStateSelectors = {
      '&:active, &:hover, &:active:hover': {
        color: linkColor,
        textDecoration: 'underline'
      }
    };

    return {
      root: [
        { selectors: stateSelectors },
        !isDisabled && {
          selectors: {
            ...activeStateSelectors
          }
        }
      ]
    };
  };
}
